import { AnyAction } from 'redux';
import {
  AngebotsId,
  GlobalActions,
  GlobalAssekuranzBeziehungChangedAction,
} from '@ps20-frontend/shop-integration-redux';
import { EinstiegResponse } from '@ps20/bff-models';
import { BeziehungZumVn } from '@ps20-frontend/frontend-models';
import { CheckoutActions } from '../checkout.actions';

export interface Beratung {
  beratername: string;
  beratungsdatum: string;
  besonderheitenBesprochen: boolean;
  extremwetterschutzBesonderheiten: string;
  besonderheiten: string;
  verkaufInnerhalbZielmarkt: boolean;
  assekuranzTarifChecked: boolean;
  assekuranzPersonenAngaben: AssekuranzPersonenAngaben[];
}

export interface AssekuranzPersonenAngaben {
  angebotsId: AngebotsId['angebotsId'];
  beziehungZumVn: BeziehungZumVn;
}

export const beratungsReducer = function (
  sectionState: Beratung = null,
  action: AnyAction,
): Beratung {
  switch (action.type) {
    case CheckoutActions.BERATUNG_BERATERNAME_CHANGED: {
      return {
        ...sectionState,
        beratername: action.payload.beratername,
      };
    }
    case CheckoutActions.BERATUNGSDATUM_GEAENDERT: {
      return {
        ...sectionState,
        beratungsdatum: action.payload.beratungsdatum,
      };
    }
    case CheckoutActions.BERATUNG_BESONDERHEITEN_BESPROCHEN_CHANGED: {
      return {
        ...sectionState,
        besonderheitenBesprochen: action.payload.besonderheitenBesprochen,
      };
    }
    case CheckoutActions.BERATUNG_BESONDERHEITEN_CHANGED: {
      return {
        ...sectionState,
        besonderheiten: action.payload.besonderheiten,
      };
    }
    case CheckoutActions.EXTREMWETTERSCHUTZ_BESONDERHEITEN_CHANGED: {
      return {
        ...sectionState,
        extremwetterschutzBesonderheiten: action.payload.extremwetterschutzBesonderheiten,
      };
    }
    case CheckoutActions.ZIELMARKT_CHANGED: {
      return {
        ...sectionState,
        verkaufInnerhalbZielmarkt: action.payload.verkaufInnerhalbZielmarkt,
      };
    }
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL: {
      const amisRequestActionPayload: EinstiegResponse = action.payload;
      const { vorname, nachname } = amisRequestActionPayload.vertreter;
      let beratername = null;
      if (!vorname) {
        beratername = `${nachname}`;
      } else {
        beratername = `${vorname} ${nachname}`;
      }
      return { ...sectionState, beratername };
    }
    case CheckoutActions.BERATUNG_ASSEKURANZ_TARIF_CHANGED: {
      return {
        ...sectionState,
        assekuranzTarifChecked: action.payload.assekuranzTarif,
      };
    }
    case GlobalActions.ASSEKURANZ_BEZIEHUNG_CHANGED:
      return updateAssekuranzBeziehung(
        sectionState,
        action as GlobalAssekuranzBeziehungChangedAction,
      );
    case GlobalActions.ASSEKURANZTARIF_CHANGED:
      return resetAssekuranzBeziehungValues(sectionState);
    default:
      return sectionState;
  }
};

function updateAssekuranzBeziehung(
  sectionState: Beratung,
  action: GlobalAssekuranzBeziehungChangedAction,
): Beratung {
  const { angebotsId, beziehungZumVn } = action.payload;
  const angabenExist = sectionState.assekuranzPersonenAngaben.some(
    angaben => angaben.angebotsId === angebotsId,
  );
  let assekuranzPersonenAngaben: Beratung['assekuranzPersonenAngaben'];
  if (angabenExist) {
    assekuranzPersonenAngaben = sectionState.assekuranzPersonenAngaben.map(angaben => {
      if (angaben.angebotsId === angebotsId) {
        return {
          ...angaben,
          beziehungZumVn,
        };
      }
      return angaben;
    });
  } else {
    assekuranzPersonenAngaben = [
      ...sectionState.assekuranzPersonenAngaben,
      { angebotsId, beziehungZumVn },
    ];
  }

  return {
    ...sectionState,
    assekuranzPersonenAngaben,
  };
}

function resetAssekuranzBeziehungValues(sectionState: Beratung): Beratung {
  return {
    ...sectionState,
    assekuranzPersonenAngaben: sectionState.assekuranzPersonenAngaben.map(angaben => ({
      ...angaben,
      beziehungZumVn: null,
    } as AssekuranzPersonenAngaben)),
  };
}
